import usePostData from '../../../../../hooks/postHook';

export const useUpdateParcelsStatusBulk = () => {
  const [{ body, isLoading, isError, error }, doUpdate] = usePostData(
    'office_parcels/status'
  );

  return {
    body,
    isLoading,
    isError,
    error,
    doUpdate,
  };
};
